import styles from './Settings.module.scss';

import SettingsInputs from 'Screens/Dashboard/Settings/SettingsInputs/SettingsInputs';

const Settings = () => (
    <div className={styles.container}>
        <SettingsInputs />
    </div>
);

export default Settings;
